import React, { useEffect } from "react";
import { X } from "lucide-react";

const Modal = ({ open, onClose, children, maxWidth = "max-w-[520px]", dismissable = true }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => event.key === "Escape" && dismissable && onClose();
    document.addEventListener("keydown", onKey);
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previous;
    };
  }, [open, onClose, dismissable]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4" onClick={() => dismissable && onClose()}>
      <div className="absolute inset-0 bg-navy-blue/40 backdrop-blur-[3px]" />
      <div className={`relative w-full ${maxWidth} bg-white rounded-[26px] shadow-xl`} onClick={(event) => event.stopPropagation()}>
        {dismissable && (
          <button onClick={onClose} className="absolute top-4 right-4 z-[1] w-9 h-9 rounded-full inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 transition">
            <X size={18} strokeWidth={2.4} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
